export default function (params = {}) {
  return { _log: 'log', ...params };
}
